import { render, staticRenderFns } from "./CarouselDesktop.vue?vue&type=template&id=2f754cae&scoped=true&"
import script from "./CarouselDesktop.vue?vue&type=script&lang=js&"
export * from "./CarouselDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CarouselDesktop.vue?vue&type=style&index=0&id=2f754cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f754cae",
  null
  
)

export default component.exports